import { FC, useCallback } from "react";
import { Button, Divider, Stack, Typography } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";
import CloudChiprLogoText from "@/assets/logos/c8r/cloudchipr-text.svg";
import AccountsIssueIcon from "@/assets/feedback-icons/accounts-issue.svg";
import { useAppSelector } from "@/store/hooks";
import { getUsersMeAccountsErrorStatusSelector } from "@/store/accounts/selectors/getUsersMeAccountsErrorStatusSelector";

export const AccountsIssue: FC = () => {
  const status = useAppSelector(getUsersMeAccountsErrorStatusSelector);

  const { logout } = useAuth0();
  const handleOnLogOutClick = useCallback(
    () => logout({ returnTo: window.location.origin }),
    [logout],
  );

  const reloadHandler = useCallback(() => {
    window.location.href = "/";
  }, []);

  if (!status || !String(status ?? "").startsWith("5")) {
    return <Navigate to="/" replace />;
  }

  return (
    <Stack height="100vh">
      <Stack p={2} alignItems="start">
        <img src={CloudChiprLogoText} alt="Cloudchipr" />
      </Stack>
      <Divider />
      <Stack alignItems="center" mt={20} gap={3.75}>
        <Typography variant="h4" color="primary.dark" fontWeight="medium">
          Something Went Wrong
        </Typography>

        <img width={270} src={AccountsIssueIcon} alt="accounts-issue" />

        <Stack spacing={2} alignItems="center">
          <Typography variant="h6" fontWeight="regular">
            An unexpected error occurred while loading the page.
          </Typography>

          <Stack direction="row" spacing={2}>
            <Button
              variant="outlined"
              size="large"
              onClick={handleOnLogOutClick}
            >
              Back To Login
            </Button>
            <Button variant="contained" size="large" onClick={reloadHandler}>
              Reload
            </Button>
          </Stack>
        </Stack>

        <Typography variant="body1" textAlign="center" color="text.secondary">
          If this continues, please contact support at <br />
          <Typography variant="inherit" color="primary" component="span">
            support@cloudchipr.com.
          </Typography>
        </Typography>
      </Stack>
    </Stack>
  );
};
